const getTicketCustomerDataChanges = (state, bookingRef) =>
  state.booking[bookingRef]?.ticketCustomerDataChanges ?? [];

export default getTicketCustomerDataChanges;
